document.addEventListener('DOMContentLoaded', () => {
  window.initGiftWrap = () => {
    setTimeout(() => {
      const btn = document.querySelector('.egwSaveGiftOptionsBtn');
      const btnMobile = document.querySelector('.tingle-modal__close');
      const textarea = document.querySelector('#effectiveAppsEgwGiftMessageText');
      const checkbox = document.querySelector('#effectiveAppsEgwGiftMessage');
      const label = document.querySelector('#effectiveAppsEGW')?.parentElement;

      if (label) label.style.display = 'flex';

      const redirectToCart = () => {
        if (!window.location.pathname.includes('/cart')) {
          localStorage.setItem('openCart', 'true');
        }
        window.location.reload();
      };

      if (btn) btn.addEventListener('click', redirectToCart);
      if (btnMobile) btnMobile.addEventListener('click', redirectToCart);

      if (textarea && checkbox) {
        textarea.addEventListener('input', () => {
          checkbox.checked = textarea.value.trim() !== '';
        });
      }
    }, 1000);


    //script remove product wrapping
    setTimeout(() => {

      // get cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // find product_type 'Gift Wrap'
          const giftWrapItems = cart.items.filter(item => item.product_type === 'Gift Wrap');
          
          // Remove 'Gift Wrap'
          giftWrapItems.forEach(item => {
            fetch(`/cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates: {
                  [item.key]: 0
                }
              })
            })
            .then(response => response.json())
            .then(data => {
              console.log(`Item ${item.id} removido do carrinho`);
            })
            .catch(error => {
              console.error('Erro ao remover o item:', error);
            });
          });
        })
        .catch(error => {
          console.error('Erro ao buscar o carrinho:', error);
        });
    
    }, 1500);
  };

  window.initGiftWrap();
});